import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://wisetech-backend.onrender.com/api",
});

/* 🔥 ADD AUTH HEADER FOR ADMIN ROUTES */
api.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem("admin_token");
    if (adminToken) {
      config.headers.Authorization = `Bearer ${adminToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
